import styled, { css } from 'styled-components';
import { flexBoxCenter } from '../styles/commonStyles';

import SSRDetailAddButton from './SSRDetailAddButton';

const DEFAULT_BUTTONS = ['add', 'clear', 'apply'];

const SSRDetailButtonContainer = ({
  handleClick,
  buttons = DEFAULT_BUTTONS,
  disabled = [],
  isMobile = false,
}) => (
  <Wrapper isMobile={isMobile}>
    <ButtonWrapper isMobile={isMobile}>
      {buttons.map((name) => (
        <SSRDetailAddButton
          handleClick={handleClick}
          name={name}
          key={name}
          isDisabled={disabled.includes(name)}
        />
      ))}
    </ButtonWrapper>
  </Wrapper>
);

export default SSRDetailButtonContainer;

const Wrapper = styled.div`
  width: 324px;
  height: 32px;

  background: transparent linear-gradient(180deg, #233a54 0%, #060d19 100%);
  box-shadow: inset 0px 0 1px #ffffff29, 0px 0px 1px #000000;
  border: 0.5px solid #000000;
  border-radius: 0 0 12px 16px;

  ${flexBoxCenter}

  justify-content: flex-start;
  padding: 0 1.5px;

  ${(p) =>
    p.isMobile &&
    css`
      width: 100%;
      border-radius: 0 0 12px 12px;
      justify-content: center;
    `}
`;
const ButtonWrapper = styled.div`
  ${flexBoxCenter}
  justify-content: space-between;

  width: 300px;
  height: 28px;

  background: #1b2b44;
  border-radius: 15px;
  padding: 0 1.5px;

  ${(p) =>
    p.isMobile &&
    css`
      width: 100%;
    `}
`;
